import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import { BasicSelect, ModelSelect } from 'vue-search-select';
import user_tracker from '../../../../usertracker'

export default {
  name: 'AddNewDestinationToGroup',
  components: {
    BasicSelect,
    ModelSelect,
    VueElementLoading,
    Multiselect
  },
  data: function () {
    return {
      useremail: '',
      cityList: [],
      modelArr: [],
      destinationcityObjData: {
        value: "",
        text: ""
      },
      destinationcityid: '',
      isLoading: false,
      allHubData: [],
      groupTypeObjData: {
        value: "",
        text: ""
      },
      groupList: [],
      DestList: [],
      groupid: '',
      // checkAllHub: false,
      checkAllConnection: false,
      isLoadingtable: false,
      cityLoading: '',
      hubLoading: '',
      zoneLoading: '',
      destinationLoading: false,
      showList: false,
      hubzoneid: 0,
      checkedHub: [],
      HubArr: [],
      listHubZoneData: [],
      listHubData: [],
      connectionList: [],
      oldDestinationList: [],
      confirmationModal: false,
      hubList: null,
      hubid: 0,
      userData: []
    }
  },

  created: function () { },
  computed: {},
  mounted() {
    let userdetailEncrypt = window.localStorage.getItem('userdetail')
    let bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    let plaintext = bytes.toString(CryptoJS.enc.Utf8);
    let userdetail = JSON.parse(plaintext)
    this.userData = userdetail;
    this.useremail = userdetail[0].email;
    this.getCityList();
  },
  methods: {
    selectedDestination(cityData) {
      this.groupTypeObjData = {};
      this.destinationcityObjData = cityData
      this.destinationcityid = cityData.value
      if (this.destinationcityid != "") {
        this.listHubZoneData = [];
        this.hubzoneid = 0;
        this.hubList = null;
        this.hubid = 0;
        this.showList = false;
        this.DestList = [];
        // this.checkAllHub = false;
        this.checkAllConnection = false;
        this.connectionList = [];
        this.getCitywiseGroups();
      }
    },

    selectedGroupType(groupTypeData) {
      this.groupTypeObjData = groupTypeData;
      this.groupid = groupTypeData.value;
      this.showList = false;
      this.checkedHub = [];
      this.hubzoneid = 0;
      this.hubList = null;
      this.hubid = 0;
      this.getDestinations();
      this.getHubZoneData();
      this.GetMappedConnection();
    },

    getCityList() {
      this.isLoading = true;
      let i = 0;
      this.input = ({})
      this.cityLoading = 'Loading City...';
      axios({
        method: 'POST',
        'url': apiUrl.api_url_hubops + 'allcity/get',
        'data': this.input,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
        }
      }).then(result => {
          let cityList = result.data.ResponseData
          for (i = 0; i < cityList.length; i++) {
            this.cityList.push({
              value: cityList[i].cityid,
              text: cityList[i].cityname
            })
          }
          this.isLoading = false;
          this.cityLoading = '';
        }, error => {
          this.isLoading = false;
          this.cityLoading = '';
          console.error(error)
        })
    },

    getHubZoneData() {
      this.listHubZoneData = [];
      this.zoneLoading = 'Loading Zone...';
      axios({
        method: 'POST',
        'url': apiUrl.api_url_hubops + 'hubzone/list',
        'data': {},
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
        }
      }).then(result => {
          if (result.data.ResultCode == 100) {
            let listHubZoneData = result.data.ResponseData;
            for (const element of listHubZoneData) {
              this.listHubZoneData.push({
                value: element.hubzoneid,
                text: element.hubzonename
              })
            }
          }
          this.zoneLoading = '';
        }, error => {
          this.zoneLoading = '';
          console.error(error);
        })
    },

    //get city wise groups
    getCitywiseGroups() {
      this.groupTypeObjData = {};
      this.groupList = [];
      let i = 0;
      this.isLoading = true;
      axios({
        method: 'GET',
        // legacy backup: getGroupfromCity
        // 'url': apiUrl.api_url_hubops + 'getGroupfromCity?cityId=' + this.destinationcityid,
        'url': apiUrl.api_url_hubops + 'groups?cityId=' + this.destinationcityid + '&isActive=true',
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
        }
      }).then(result => {
          if (result.data.ResultCode == 100) {
            let groupList = result.data.ResponseData
            for (i = 0; i < groupList.length; i++) {
              this.groupList.push({
                value: groupList[i].groupid,
                text: groupList[i].groupname + ' - ' + groupList[i].routemode + ' - ' + groupList[i].groupno
              })
            }
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
          this.isLoading = false;
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    },

    selectedHub(data) {
      this.hubid = data.value;
      if (this.oldDataSaved == false) {
        this.oldDestinationList = this.DestList;
        this.oldDataSaved = true;
      }
      let arr = [];
      for (const element of this.oldDestinationList) {
        for (let j = 0; j < element.length; j++) {
          if (Number(element[j].hubId) == Number(this.hubid)) {
            arr.push(element[j]);
            break;
          }
        }
      }
      this.DestList = []
      this.DestList.push(arr);
    },

    selectedZone() {
      this.oldDestinationList = this.DestList;
      this.getDestinations();
    },

    resetZoneHub() {
      this.hubList = null;
      this.hubid = 0;
      this.hubzoneid = 0;
      this.getDestinations();
    },

    //get group wise Destinations list
    getDestinations() {
      this.DestList = [];
      this.destinationLoading = true;
      this.listHubData = [];
      this.hubList = null;
      this.hubid = 0;
      this.destData = [];
      this.HubArr = [];
      // this.checkAllHub = false;
      this.hubLoading = 'Loading Hub...';
      axios({
        method: 'GET',
        'url': apiUrl.api_url_hubops + 'fetchMappedDestinations?groupid=' + this.groupid + ((this.hubzoneid !== 0) ? '&hubzoneid=' + this.hubzoneid : ''),
        headers: {
          'Authorization': "authkey xB84JJ89Hd25"
        }
      }).then(result => {
          if (result.data.ResultCode == 100) {
            let j = 0, list = [], dlist = [];
            let hData = result.data.ResponseData;
            if (hData.length !== 0) {
              for (const element of hData) {
                this.listHubData.push({
                  value: element.HubID,
                  text: element.HubName + '(' + element.HubID + ')'
                });

                if (typeof this.checkedHub[element.HubID] == 'undefined') {
                  this.checkedHub[element.HubID] = element.IsChecked;
                }
                if (element.IsChecked && !this.modelArr.includes(element.HubID))
                  this.modelArr.push(element.HubID);
                if (j < 4) {
                  list.push({
                    hubId: element.HubID,
                    hubName: element.HubName
                  });
                } else {
                  dlist.push(list);
                  list = []
                  list.push({
                    hubId: element.HubID,
                    hubName: element.HubName
                  });
                  j = 0;
                }
                j++;

                (this.HubArr.indexOf(element.HubID) === -1) ? this.HubArr.push(element.HubID) : '';
                this.destData.push({
                  hubId: element.HubID,
                  hubName: element.HubName
                });

                const allH = this.allHubData.some(el => el.hubId === element.HubID);
                if (!allH) {
                  this.allHubData.push({
                    hubId: element.HubID,
                    hubName: element.HubName
                  });
                }
              }
              dlist.push(list);
              this.DestList = dlist;
              this.oldDataSaved = false;
            }
            this.showList = true;
          } else {
            this.$alertify.error(result.data.ReturnMessage, "", "error");
          }
          this.destinationLoading = false;
          this.hubLoading = '';
        }, error => {
          console.error(error);
          this.destinationLoading = false;
          this.hubLoading = '';
        })
    },

    /*select all and update function for destination list */
    // checkHub() {
    //   if (typeof InstallTrigger !== 'undefined' == true) { this.checkAllHub = !this.checkAllHub; }

    //   if (this.checkAllHub) {
    //     for (const element of this.destData) {
    //       this.checkedHub[element.hubId] = true;
    //       this.modelArr.indexOf(element.hubId) === -1 ? this.modelArr.push(parseInt(element.hubId)) : '';
    //     }
    //   } else {
    //     let arr = [];
    //     for (const element of this.destData) {
    //       this.checkedHub[element.hubId] = false;
    //       arr.push(element.hubId);
    //     }
    //     this.modelArr = this.modelArr.filter(val => !arr.includes(val));
    //   }
    //   if (this.oldDataSaved == true) {
    //     for (const element of this.oldDestinationList) {
    //       for (const elmnt of element) {
    //         this.checkedHub[elmnt.hubId] = this.checkAllHub;
    //       }
    //     }
    //   }
    // },

    updateCheckDest(event) {
      this.checkedHub[event.target.id] = event.target.checked;

      if (event.target.checked == false) {
        this.modelArr = this.modelArr.filter(el => el != event.target.id)
      } else {
        this.modelArr.indexOf(event.target.id) === -1 ? this.modelArr.push(parseInt(event.target.id)) : '';
      }
      // this.checkAllHub = (this.destData.length === this.modelArr.length) ? true : false;
    },

    //get the connections having in group
    GetMappedConnection() {
      this.isLoadingtable = true;
      this.checkAllConnection = false;
      this.connectionList = [];
      axios({
        method: 'GET',
        'url': apiUrl.api_url_hubops + 'fetchMappedConnections?groupid=' + this.groupid,
        headers: {
          'Authorization': "authkey xB84JJ89Hd25"
        }
      }).then(result => {
          if (result.data.ResultCode == 100) {
            let DestResultData = result.data.ResponseData;
            if (DestResultData.length > 0) {
              this.checkAllConnection = true;
              DestResultData.map(conn => {
                conn.isselected = true;
              });
              this.connectionList = DestResultData;
            }
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
          this.isLoadingtable = false;
        }, error => {
          this.isLoadingtable = false;
          console.error(error)
        })
    },
    
    /*select all and update function for Connnection list */
    checkConnections() {
      if (this.checkAllConnection) {
        for (const element of this.connectionList) {
          element.isselected = true
        }
      } else {
        for (const element of this.connectionList) {
          element.isselected = false
        }
      }
    },

    updateConnectionList() {
      this.checkAllConnection = false;
      let selectedrecords = this.connectionList.filter(item => item.isselected)
      if (selectedrecords.length == this.connectionList.length) {
        this.checkAllConnection = true;
      }
    },

    mapMultipleDestinationsToConnection() {
      this.confirmationModal = false;
      let desthubList = [];
      for (const element of this.allHubData) {
        if (this.checkedHub[element.hubId]) {
          desthubList.push(
            element.hubId
          );
        }
      }

      let connectionMappedlist = this.connectionList.filter(function (i) {
        return i.isselected;
      }).map(function (i) {
        return (i.connectiongroupmappingid);
      });

      if (desthubList.length == 0 || connectionMappedlist.length == 0) {
        return this.$alertify.error('Destination or Connection list should not be empty', "", "error");
      }
      this.isLoadingtable = true;
      this.input = {
        groupid: this.groupid,
        destinationidlist: desthubList,
        conngroupmappingidlist: connectionMappedlist,
        createdby: this.useremail
      }

      axios({
        method: 'POST',
        'url': apiUrl.api_url_hubops + "mapdestinationtoconnection",
        'data': this.input,
        headers: {
          'Authorization': "authkey xB84JJ89Hd25"
        }
      }).then(result => {
          if (result.data.ResultCode == 100) {
            this.$alert(result.data.ReturnMessage, "", "success");
            user_tracker.checkUserIP(this.userData[0], "AddNewDestinationToGroup", this.$route.path , this.input);
            this.resetForm();
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
          this.isLoadingtable = false;
        }, error => {
          this.isLoadingtable = false;
          console.error(error)
        })
    },

    onSubmitHub: function (elem) {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.confirmationModal = true;
        } else {
          console.log('save error'); return false;
        }
      }).catch(() => { });
    },

    closeModal() {
      this.confirmationModal = false;
    },

    resetForm() {
      this.DestList = [];
      this.oldDestinationList = [];
      this.listHubData = [];
      this.isLoading = false;
      this.groupid = '';
      this.groupTypeObjData = {
        value: "",
        text: ""
      };
      this.destinationcityObjData = {
        value: "",
        text: ""
      };
      this.destinationcityid = '';
      // this.checkAllHub = false;
      this.isLoadingtable = false;
      this.cityLoading = '';
      this.parentHub = '';
      this.confirmationModal = false;
      this.connectionList = [];
      this.checkAllConnection = false;
      this.allHubData = [];
      this.groupList = [];
      this.checkedHub = [];
      this.modelArr = [];
      this.hubzoneid = 0;
      this.hubList = [];
      this.hubid = 0;
      this.listHubZoneData = [];
      this.showList = false;
      this.$validator.reset();
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/groupnew/AddNewDestinationToGroup/AddNewDestinationToGroup.js